import { LOADING } from '../constants'

export const APP_ACTION = {
  DOWNLOAD: 'Download_Action',
  UPLOAD: 'Upload_Action',
  PRINT: 'Print_Action',
  CALCULATION: 'Calculation_Action',
}

export const getAppEventName = (appCode, ecMode = false) =>
  ecMode ? `${appCode}_Events_B2B` : `${appCode}_Events`

export const flattenGAValue = (source) => {
  const target = {}

  const helper = (current, target, keyPrefix) => {
    for (let key in current) {
      let val = current[key]

      if (typeof val !== 'object') {
        if (keyPrefix === null || keyPrefix === '') {
          target[key] = val
        } else {
          if (key === null || key === '') {
            target[keyPrefix] = val
          } else {
            target[keyPrefix + '_' + key] = val
          }
        }
      } else {
        if (keyPrefix === null || keyPrefix === '') {
          helper(val, target, key)
        } else {
          helper(val, target, keyPrefix + '_' + key)
        }
      }
    }
  }

  helper(source, target, '')

  return target
}

export const formatGAEventLabel = (obj, labelName) => {
  const flattedObj = flattenGAValue(obj)

  return Object.entries(flattedObj).reduce(
    (result, [key, val]) => result + ' - ' + key + ':' + (val != undefined ? String(val) : 'N/A'),
    labelName,
  )
}

export const formatDataLayerInput = (obj) => {
  const flattedObj = flattenGAValue(obj)

  return Object.entries(flattedObj).reduce((result, [key, val]) => {
    result[key] = val != undefined ? String(val) : 'N/A'

    return result
  }, {})
}

export const doGAEvent = (appEventName, action, label) => {
  try {
    ga('send', 'event', appEventName, action, label)
  } catch (err) {
    console.log(`${err} - Cannot track the GA3 event!`)
  }
}

export const doDataLayerEvent = (payload) => {
  try {
    window.dataLayer?.push({
      event: 'webApps',
      ...payload,
    })
  } catch (err) {
    console.log(`${err} - Cannot track the GA4 event!`)
  }
}

export const handleGAEvent = ({
  appEventName,
  gaActionName,
  gaLabelName,
  gaInputData,
  gaOutputData,
}) => {
  const { query, data, error: message, loading } = gaOutputData

  const gaInput = Object.assign(
    {},
    gaInputData,
    query,
    {
      solutionFound:
        gaActionName === APP_ACTION.UPLOAD
          ? 'N/A'
          : loading === LOADING.SUCCEEDED && data?.length > 0,
    },
    message ? { message } : {},
  )

  const formattedGALabel = formatGAEventLabel(gaInput, gaLabelName)

  doGAEvent(appEventName, gaActionName, formattedGALabel)
}

export const handleDataLayerEvent = ({
  appName,
  appAction,
  appInputs,
  appOutputData,
  gaOutputs,
  extraParams,
}) => {
  const payload = Object.assign(
    {
      app_name: appName,
      app_action: appAction,
    },
    extraParams
      ? extraParams
      : gaOutputs
      ? {
          outputs: gaOutputs,
        }
      : {
          solution_found:
            appAction === APP_ACTION.UPLOAD
              ? 'N/A'
              : appOutputData.loading === LOADING.SUCCEEDED && appOutputData.data?.length > 0
              ? 'Yes'
              : 'No',
          inputs: formatDataLayerInput(appInputs),
        },
  )

  doDataLayerEvent(payload)
}
